(() => {
  'use strict';
  const t = window.BCMJourneyText || {};
  const init = () => document.querySelectorAll('[data-bcm-room-planner]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const list = root.querySelector('[data-bcm-room-list]');
    const summary = root.querySelector('[data-bcm-room-summary]');
    const status = root.querySelector('[data-bcm-room-status]');
    const addButton = root.querySelector('[data-bcm-room-add]');
    let serial = 0;
    function update() {
      const rooms = Array.from(list.children);
      let beds = 0;
      let budget = 0;
      let hasBudget = false;
      const lines = rooms.map((row, index) => {
        const name = row.querySelector('[data-room-name]').value.trim() || `${t.room} ${index + 1}`;
        const count = Number(row.querySelector('[data-room-count]').value);
        const perBed = row.querySelector('[data-room-budget]').value;
        const validCount = Number.isInteger(count) && count >= 1 && count <= 50;
        if (validCount) beds += count;
        if (perBed !== '' && validCount && Number(perBed) >= 0) { hasBudget = true; budget += count * Number(perBed); }
        const budgetText = perBed === '' ? t.budget_unspecified : `$${Number(perBed).toFixed(2)} ${t.per_bed}`;
        return `${name}: ${validCount ? count : '?'} × ${row.querySelector('[data-room-size]').value}; ${budgetText}`;
      });
      const total = `${t.total_beds}: ${beds}`;
      const money = hasBudget ? `${t.planned_budget}: $${budget.toFixed(2)}` : t.budget_unspecified;
      summary.value = [t.planner_heading, ...lines, total, money, t.plan_note].join('\n');
      status.textContent = `${total}\n${money}`;
      addButton.disabled = rooms.length >= 20;
      root.querySelector('[data-bcm-room-inquire]').setAttribute('aria-disabled', rooms.length === 0 ? 'true' : 'false');
      return rooms.every(row => Array.from(row.querySelectorAll('input')).every(input => input.checkValidity()));
    }
    function addRoom() {
      if (list.children.length >= 20) return;
      const row = document.createElement('div');
      row.className = 'bcm-room-row';
      const fields = document.createElement('div');
      fields.className = 'bcm-room-fields';
      const addField = (labelText, type, attribute, options) => {
        const label = document.createElement('label');
        label.textContent = labelText;
        const input = document.createElement(options ? 'select' : 'input');
        input.id = `bcm-room-${serial}-${attribute}`;
        input.setAttribute(attribute, '');
        if (options) options.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; input.append(option); });
        else input.type = type;
        label.append(input); fields.append(label); return input;
      };
      serial += 1;
      const name = addField(t.room_name, 'text', 'data-room-name'); name.maxLength = 80;
      const count = addField(t.bed_count, 'number', 'data-room-count'); count.min = '1'; count.max = '50'; count.step = '1'; count.value = '1'; count.required = true;
      addField(t.size, '', 'data-room-size', ['Queen', 'King', 'California King', 'Full', 'Twin XL', 'Twin']);
      const budget = addField(t.budget_per_bed, 'number', 'data-room-budget'); budget.min = '0'; budget.max = '100000'; budget.step = '0.01';
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = t.remove_room;
      remove.addEventListener('click', () => { row.remove(); update(); addButton.focus(); });
      row.append(fields, remove); list.append(row); update(); return name;
    }
    addButton.addEventListener('click', () => addRoom()?.focus());
    list.addEventListener('input', update); list.addEventListener('change', update);
    root.querySelector('[data-bcm-room-copy]').addEventListener('click', async () => {
      if (!update()) { status.textContent = t.correct_rooms; return; }
      try { await navigator.clipboard.writeText(summary.value); status.textContent = t.plan_copied; }
      catch { summary.focus(); summary.select(); status.textContent = t.copy_manually; }
    });
    root.querySelector('[data-bcm-room-print]').addEventListener('click', () => {
      if (!update()) { status.textContent = t.correct_rooms; return; }
      const sheet = document.createElement('div'); sheet.setAttribute('data-bcm-print-sheet', ''); sheet.textContent = summary.value;
      document.body.append(sheet); document.body.classList.add('bcm-print-plan');
      const cleanup = () => { sheet.remove(); document.body.classList.remove('bcm-print-plan'); };
      window.addEventListener('afterprint', cleanup, { once: true });
      window.print();
      window.setTimeout(cleanup, 60000);
    });
    root.querySelector('[data-bcm-room-download]').addEventListener('click', () => {
      if (!update()) { status.textContent = t.correct_rooms; return; }
      const url = URL.createObjectURL(new Blob([summary.value], { type: 'text/plain;charset=utf-8' }));
      const link = document.createElement('a'); link.href = url; link.download = 'BCM-bedroom-plan.txt'; link.click(); window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    });
    root.querySelector('[data-bcm-room-inquire]').addEventListener('click', event => {
      if (!list.children.length || !update()) { event.preventDefault(); status.textContent = t.correct_rooms; return; }
      try { sessionStorage.setItem('bcm.room-plan.handoff.v1', JSON.stringify({ createdAt: Date.now(), text: summary.value })); }
      catch { event.preventDefault(); summary.focus(); summary.select(); status.textContent = t.copy_manually; }
    });
    root.querySelector('[data-bcm-room-reset]').addEventListener('click', () => { list.replaceChildren(); addRoom()?.focus(); });
    addRoom();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
